import React, { useState } from "react"
import PropTypes from "prop-types"
import { css } from "@emotion/core"
import { useTranslation } from "gatsby-plugin-react-i18next"

import Navbar from "./navigation/navbar"
import Footer from "./footer/footer"
import Consent from "./consent/consent"
import { Helmet } from "react-helmet"

if (typeof window !== "undefined") {
  require("smooth-scroll")('a[href*="#"]')
}

const mainCss = css`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(16px, 1fr) repeat(12, minmax(24px, 95px)) minmax(
      16px,
      1fr
    );
  align-items: start;
  flex: 0 1;
  padding-top: 150px;

  @media (max-width: 767px) {
    padding-top: 72px;
  }
`

const Scripts = () => {
  return (
    <Helmet>
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-8TEXLE0H0Y"
      ></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}

          gtag('js', new Date());
          gtag('config', 'G-8TEXLE0H0Y', { 'anonymize_ip': true, 'allow_google_signals': false });
          gtag('set', 'allow_google_signals', false);
      `}
      </script>
    </Helmet>
  )
}

const IsIE = () => {
  if (typeof window !== `undefined`) {
    return window.navigator.userAgent.match(/(MSIE|Trident)/)
  }
}

const Layout = ({ children }) => {
  const [sideDrawerOpen, setSideDrawerOpen] = useState(false)
  const [analyticsEnabled, setAnalyticsEnabled] = useState(false)
  const { t } = useTranslation()

  const handleAnalytics = shouldSetAnalytics => {
    if (typeof window !== `undefined`) {
      if (!shouldSetAnalytics) {
        window["ga-disable-G-8TEXLE0H0Y"] = true
        document.cookie =
          "_hjOptOut=true; expires=Fri, 31 Dec 9999 23:59:59 GMT"
      } else {
        window["ga-disable-G-8TEXLE0H0Y"] = false
        document.cookie =
          "_hjOptOut=false; expires=Fri, 31 Dec 9999 23:59:59 GMT"
      }
      localStorage.setItem("analyticsEnabled", shouldSetAnalytics)
      setAnalyticsEnabled(shouldSetAnalytics)
    }
  }

  React.useEffect(() => {
    const lclStorageEnabled = JSON.parse(
      localStorage.getItem("analyticsEnabled")
    )
    setAnalyticsEnabled(lclStorageEnabled)
    if (lclStorageEnabled) {
      window["ga-disable-G-8TEXLE0H0Y"] = false
      document.cookie = "_hjOptOut=false; expires=Fri, 31 Dec 9999 23:59:59 GMT"
    } else {
      window["ga-disable-G-8TEXLE0H0Y"] = true
      document.cookie = "_hjOptOut=true; expires=Fri, 31 Dec 9999 23:59:59 GMT"
    }
  }, [])

  if (IsIE()) {
    alert(t("skeleton.internetExplorer"))
    window.open("https://www.google.com/chrome/")
  }

  return (
    <>
      {analyticsEnabled && <Scripts />}
      <Navbar
        show={sideDrawerOpen}
        hamburgerClickHandler={() => {
          setSideDrawerOpen(!sideDrawerOpen)
          document.getElementById("hamburger").classList.toggle("is-active")
        }}
      />
      <Consent handleAnalytics={handleAnalytics} />
      <main css={mainCss} aria-hidden={sideDrawerOpen}>
        {children}
      </main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
